
export default {
  components: {},
  props: {
    tabs: {
      type: Array,
      default: () => {}
    }
  },
  data() {
    return {
      switchate: this.$store.state.host.includes('wikifx') ? 2 : 1 // 1为手机号验证码登录/2为手机号邮箱登录
    }
  },
  watch: {
    switchate: {
      handler(newName) {
        this.$emit('switch', newName)
        this.switchate = newName
      }
      // immediate: true
    }
  },
  mounted() {},
  methods: {}
}
